<template>
  <section class="relative py-14 lg:py-0 lg:h-[600px] flex items-center justify-center overflow-hidden">
    <!-- Imagem de fundo -->
    <AppImg :src="`${assetsPath}img/banner-home-mais-ifmg.jpg`" alt="Banner" class="absolute w-full overflow-clip" />
    <!-- Overlay com gradiente -->
    <div class="absolute inset-0 bg-gradient-to-r from-[#039B75]/80 to-[#01365A]/80"></div>
    <!-- Conteúdo -->
    <div class="relative text-center text-white px-4 max-w-4xl">
      <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
        Plataforma +IFMG
      </h1>
      <p class="text-lg md:text-xl lg:text-2xl mb-8">
        Cursos gratuitos e com certificação online!
      </p>
      <UButton variant="outline" size="xl" @click="openModalRegister"
        class="rounded-full px-8 py-3 border-2 ring-transparent text-white border-white hover:border-white hover:bg-white hover:text-gray-500 hover:cursor-pointer">
        Inscreva-se
      </UButton>
    </div>
  </section>
</template>
<script setup lang="ts">
const config = useRuntimeConfig()
const uiStore = useUiStore()
const userStore = useUserStore()
const router = useRouter()

const assetsPath = config.public.assetsPath

const openModalRegister = () => {
  if (userStore.isLoggedIn) {
    uiStore.isAuthModalOpen = false
    navigateTo(`/categoria/`)
  } else {
    router.replace({ hash: `#register` })
    uiStore.isAuthModalOpen = true
  }
}
</script>